import agile from './agile.png'
import sql from './sql.png'
import testRigor from './testrigor.png'
import webdriverio from './webdriverio.png'

export const Certifications = [
    {
        id:"1",
        courseName: "MasterClass Software Testing with Jira & Agile -Be a QA Lead",
        courseImage: agile,
        courselink: 'https://www.udemy.com/course/learn-software-testing-in-practical-become-a-qa-expert/?kw=MasterClass+Software+Testing+with+Jira+%26+Agile+-Be+a+QA+Lead&src=sac&couponCode=ST21MT30625G1',
        courseDesc: 'Straight to the point. 2025 BEST job oriented Software Manual Testing course on real time Projects + Interview questions',
        courseCertificateLink: "https://drive.google.com/file/d/1ZuNW0z40IyicxckpKUTRni8C1mbiqhEg/view?usp=sharing",
    },
    {
        id:"2",
        courseName: "WebDriverIO-JavaScript UI Automation from Scratch",
        courseImage: webdriverio,
        courselink: 'https://www.udemy.com/course/webdriverio-tutorial-nodejs-javascript/?couponCode=ST21MT30625G1',
        courseDesc: 'Top class tutorial on WebDriverIO ( Selenium JavaScript) Automation Testing',
        courseCertificateLink: "https://drive.google.com/file/d/1JTVgFZdfm177BRQHybXXC_b3tU05zBMQ/view?usp=sharing",
    },
     {
        id:"3",
        courseName: "The Complete SQL Bootcamp: Go from Zero to Hero",
        courseImage: sql,
        courselink: 'https://www.udemy.com/course/the-complete-sql-bootcamp/?couponCode=ST21MT30625G1',
        courseDesc: 'Become an expert at SQL: Use SQL to query a database,Use SQL to perform data analysis etc.',
        courseCertificateLink: "https://drive.google.com/file/d/1KtJWkqw7Q4xdSt8ESgnirsjCrbyzjZjz/view?usp=sharing",
    },
    {
        id:"4",
        courseName: "(testRigor)AI-driven Test Automation Engineer",
        courseImage: testRigor,
        courselink: 'https://testrigor.com/certificates/ozCWdtPFmFx5rZ1DQ88fcoAx',
        courseDesc: 'AI-driven Test Automation Engineer (testRigor)',
        courseCertificateLink: "https://testrigor.com/certificates/ozCWdtPFmFx5rZ1DQ88fcoAx",
    }
]
